import { useContentOverflow } from '../../../../../../hooks'
import { FloatingTooltip } from '../../../../../Floating'
import Text from '../../../../../Text'

import * as styles from './ListingProfileWidgetPerformanceItem.module.css'

function ListingProfileWidgetPerformanceItem({ label, metricKey, value }) {
  const { overflow: isValueOverflow, setContentOverflowRef: setValueRef } =
    useContentOverflow({ dep: [value] })

  const { overflow: isLabelOverflow, setContentOverflowRef: setLabelRef } =
    useContentOverflow({ dep: [label] })

  return (
    <div className={styles.ListingProfileWidgetPerformanceItem}>
      <FloatingTooltip content={value} disabled={!isValueOverflow}>
        <Text className={styles[metricKey]} ref={setValueRef}>
          {value}
        </Text>
      </FloatingTooltip>
      <FloatingTooltip content={label} disabled={!isLabelOverflow}>
        <Text isSecondary className={styles.label} ref={setLabelRef}>
          {label}
        </Text>
      </FloatingTooltip>
    </div>
  )
}

export default ListingProfileWidgetPerformanceItem
